import { PREVIEW_ID_ATTRIBUTE } from './_consts.js';
/**
 * Manual polyfill. 
 * The elements provided by MutationObserver do not seem to be enhanced by babel-polyfills.
 */
if (!Element.prototype.matches) {
  Element.prototype.matches = Element.prototype.msMatchesSelector ||
                              Element.prototype.webkitMatchesSelector;
}
const observer = (mutationsList) => {

  for (const mutation of mutationsList) {
    if (mutation.removedNodes.length !== 0) findRemovedNodes(...mutation.removedNodes);
    if (mutation.addedNodes.length !== 0) findInsertedNodes(...mutation.addedNodes);
    if (mutation.type === 'attributes') {
      findRemovedNodes(mutation.target);
      findInsertedNodes(mutation.target);
    }
  }

};

const _observer = new MutationObserver(observer);
const _nodes = new Map();

let _root, _selector, _attribute, _onInsert, _onRemove;

const _createNodeApplyer = (fn) => (...subtrees) => subtrees
  .filter(subtree => subtree instanceof HTMLElement)
  .forEach(subtree => {
    if (subtree.matches(_selector)) fn(subtree);
    for (const node of subtree.querySelectorAll(_selector)) fn(node);
  });

const findInsertedNodes = _createNodeApplyer(node => {
  window.clearTimeout(_nodes.get(node));
  _nodes.set(node, window.setTimeout(() => {
    _onInsert(node, node.getAttribute(_attribute));
    _nodes.set(node, true);
  }, 1));
});

const findRemovedNodes = _createNodeApplyer(node => {
  window.clearTimeout(_nodes.get(node));
  if (_nodes.get(node) === true) {
    _nodes.set(node, window.setTimeout(() => {
      _onRemove(node);
      _nodes.delete(node);
    }, 1));
  } else {
    _nodes.delete(node);
  }
});

export default ({ onInsert, onRemove, root = document.body, attribute = PREVIEW_ID_ATTRIBUTE, selector = `[${attribute}]` }) => {
  _onInsert = onInsert;
  _onRemove = onRemove;
  _root = root;
  _attribute = attribute;
  _selector = selector;
  _observer.observe(_root, { subtree: true, childList: true, attributes: true, attributeFilter: [_attribute] });
  findInsertedNodes(_root);
};
